package fr.manyverse.app.infrastructure.clipboard

import kotlinx.browser.window

/**
 * Web/JS implementation of ClipboardManager using the Clipboard API.
 */
class JsClipboardManager : ClipboardManager {
    override fun copyToClipboard(text: String) {
        window.navigator.clipboard.writeText(text)
    }
}

actual fun createClipboardManager(): ClipboardManager = JsClipboardManager()
